/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import type { AxiosRequestConfig, AxiosResponse } from "axios"
import { env } from '$env/dynamic/public';
import { axiosHandler } from "../axiosHandler";
import { datadogLogs } from "@datadog/browser-logs";

export const emailTranscript = async (requestData: {
    email: string, conversation_id: string, brand: string, channel: string, browser_uuid: string
}, token: string): Promise<AxiosResponse<string> | string> => {
    const protocol = env.PUBLIC_NODE_ENV === 'dev' ? 'http://' : 'https://'
    const route = env.PUBLIC_NODE_ENV === 'dev' ? '/webchat/email-transcript' : '/r/api/conversational/garden-webchat-api/webchat/email-transcript'
    try {
        const config: AxiosRequestConfig = {
            method: 'POST',
            url: `${protocol}${env.PUBLIC_DOMAIN_URL}${route}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, },
            data: { conversationId: requestData.conversation_id, email: requestData.email },
        };
        const response = await axiosHandler<string>(config);
        datadogLogs.logger.info(
            `[Conv-ui] Email Transcript Success - brand: ${requestData.brand} channel: ${requestData.channel} browser_uuid: ${requestData.browser_uuid} conversation_id: ${requestData.conversation_id}`
        );
        return response?.data
    } catch (error) {
        datadogLogs.logger.error(`[Conv-ui] Email Transcript Failure - brand: ${requestData.brand} browser_uuid: ${requestData.browser_uuid} error: ${error}`)
        return ''
    }
}